export default __webpack_public_path__ + "static/media/profile-bg.b29e50f6.jpg";